import React from 'react';

import Image from 'next/image';
import { Button, Text } from '@BICE_Vida/components';

import { contactabilityFormTexts } from '@/utils/generalTexts';
import { SUCCESS_CONTACT_ICON_CHECK, ERROR_CONTACT_ICON } from '@/utils/assets';
import { trackClick, clickActionsEvents } from '@/utils/dataLayer/home';

import styles from './ContactabilityResult.module.scss';

interface ContactabilityResultProps {
  readonly status: 'success' | 'error';
  readonly onClose: () => void;
}

function ContactabilityResult({ status, onClose }: ContactabilityResultProps) {
  const isSuccess = status === 'success';

  const handleClose = () => {
    trackClick({ action: clickActionsEvents.contactExecutiveClose });
    onClose();
  };

  return (
    <div className={styles.result_container}>
      <div className={styles.result_content}>
        <div className={isSuccess ? styles.result_icon_success : styles.result_icon_error}>
          <Image
            src={isSuccess ? SUCCESS_CONTACT_ICON_CHECK : ERROR_CONTACT_ICON}
            alt={isSuccess ? 'Envío exitoso' : 'Error en el envío'}
            width={80}
            height={80}
          />
        </div>
        <div className={styles.result_text}>
          <Text tag="h2" color="primary" className={styles.result_title}>
            {isSuccess ? contactabilityFormTexts.successTitle : contactabilityFormTexts.errorTitle}
          </Text>
          <Text tag="p" className={styles.result_description}>
            {isSuccess
              ? contactabilityFormTexts.successSubtitle
              : contactabilityFormTexts.errorSubtitle}
          </Text>
        </div>
      </div>
      <Button
        className={styles.btn_finish_contact}
        id={`header_btn_contact_finished`}
        text={contactabilityFormTexts.modalButtonSubmit}
        size="large"
        onClick={handleClose}
        aria-label={'header_btn_finish_contact'}
        variant="primary"
      />
    </div>
  );
}

export default ContactabilityResult;
